import React from 'react';

const PayPayment = () => {
    return (
        <div>
           hey 
        </div>
    );
};

export default PayPayment;